import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";
import { Week } from "../schemas/keepInTouch";

/** Server `GET /admin/users` row (core/adminUsers.ts) plus the digest flag. */
export const AdminUser = S.Struct({
	actorId: S.String,
	circleId: S.String,
	circleName: S.String,
	name: S.String,
	email: S.String,
	imageUrl: S.NullOr(S.String),
	joinedAt: S.String,
	lastActiveAt: S.NullOr(S.String),
	records: S.Number,
	entries: S.Number,
	digestSubscribed: S.Boolean,
});
export type AdminUser = typeof AdminUser.Type;

export const AdminUsers = S.Struct({ data: S.Array(AdminUser) });
export type AdminUsers = typeof AdminUsers.Type;

export const AdminDetail = S.Struct({
	week: Week,
	/** Entries per week, oldest first, twelve buckets ending this week. */
	entriesByWeek: S.Array(S.Number),
});
export type AdminDetail = typeof AdminDetail.Type;

export const { getAdminUsers } = staticApis({
	getAdminUsers: ["GET", "/admin/users", AdminUsers],
});

export const getAdminDetail = defineApi("GetAdminDetail", {
	args: { circleId: S.String },
	response: AdminDetail,
	request: ({ circleId }) => ({
		method: "GET",
		path: `/admin/users/${encodeURIComponent(circleId)}`,
	}),
});

export const sendReminder = defineApi("SendReminder", {
	args: { circleId: S.String, email: S.String },
	response: S.Struct({ sent: S.Boolean }),
	request: ({ circleId, email }) => ({
		method: "POST",
		path: `/admin/users/${encodeURIComponent(circleId)}/reminder`,
		body: { email },
	}),
});

export const setAdminDigest = defineApi("SetAdminDigest", {
	args: { email: S.String, subscribed: S.Boolean },
	response: S.Struct({ subscribed: S.Boolean }),
	request: (body) => ({ method: "PUT", path: "/admin/digest", body }),
});
